import React from 'react';
import {get} from 'lodash';

import {useTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';

interface PeopleRoleProps {
  item: {
    isFrontline?: boolean;
    customerType?: number;
    level?: number;
  };
}

export const PeopleRole: React.FC<PeopleRoleProps> = ({item}) => {
  const {tt} = useTranslation('report.record.peopleRole');

  const isFrontline = get(item, 'isFrontline', false);
  const level = get(item, 'level', null);
  const customerTypeCode = get(item, 'customerType', 2);

  const customerType = customerTypeCode === 2 ? 'Client' : 'Coach';
  const isGen0 = level === 0 || level === 1;

  const renderPeopleRole = () => {
    if (isFrontline) {
      return tt(
        'frontlineCustomer',
        generateComponentCallback({
          component: <>{`${customerType} · Frontline`}</>,
        }),
      );
    } else if (isGen0) {
      return tt(
        'genOCustomer',
        generateComponentCallback({
          component: <>{`${customerType} · GEN0`}</>,
        }),
      );
    } else {
      return <>{customerType}</>;
    }
  };

  return renderPeopleRole();
};

export default PeopleRole;
